module.exports = __webpack_public_path__ + "static/media/home-service-slider-13.0a332a3a.jpg";